import {APP_MEDIAQUERY} from './app-mediaquery';
import VueCookies from 'vue-cookies';
import ApiConfig from '../api/api.config';
import router from '../router';
import OwnerApi from '../api/owner';
import VendorApi from '../api/vendor';
import _ from "lodash";
import Moment from "moment";
import store from "../store";

const TOKEN_NAME = 'token';

export default {

  Portals: {
    OWNER: 'owner',
    VENDOR: 'vendor',
    RESERVATION: 'reservation',
    STAFF: 'staff'
  },

  PaymentProcessors: {
    SLIM_CD: 'SLIM_CD',
    VRP: 'VRP'
  },

  BookingStatus: {
    CURRENT: 'CURRENT', // :NOTE: RJW - Not sure if this actually a valid status?
    ARCHIVED: 'ARCHIVED',
    CANCELLED: 'CANCELLED',
    UNKNOWN: 'UNKNOWN',
    paymentsAllowed: function(status) {
      return status === this.CURRENT;
    }
  },

  /**
   * Check if the media query indicates we're on a mobile device.
   *
   * @return {boolean}
   */
  isMobile() {
    return screen.width < APP_MEDIAQUERY.tablet;
  },

  getToken() {
    return VueCookies.get(TOKEN_NAME);
  },

  initUrl(url, includeToken = true) {
    const result = ApiConfig.API_URL + url;

    // We have enough if we don't need to include the auth token.
    if (!includeToken) {
      return result;
    }

    const token = VueCookies.get(TOKEN_NAME);

    // Preserve query string parameters.
    if (url.indexOf('?') > -1) {
      return result + '&' + TOKEN_NAME + '=' + token;
    } else {
      return result + '?' + TOKEN_NAME + '=' + token;
    }
  },

  showLoading() {
    store.dispatch('common/showLoading');
  },

  hideLoading() {
    store.dispatch('common/hideLoading');
  },

  /**
   * Methods to retrieve session information.
   */
  Session: (() => {
    let that = {};

    that.UserInfo = 'userInfo';
    that.LoginSettings = 'loginSettings';

    that.getUserInfo = function() {
      return JSON.parse(localStorage.getItem(that.UserInfo));
    };

    that.getLoginSettings = function() {
      return JSON.parse(localStorage.getItem(that.LoginSettings));
    };

    const data = that.getLoginSettings() || {};

    const parts = window.location.host.split('.');
    const config = parts[0].split('-');

    data.prefixCode = config[1];
    data.portal = config[0];
    localStorage.setItem(that.LoginSettings, JSON.stringify(data));
    return that;
  })(),

  logout() {
    store.dispatch('common/closeSidebar');
    const portal = this.Session.getLoginSettings();
    if (VueCookies.get(TOKEN_NAME)) {
      if (portal === this.Portals.OWNER) {
        OwnerApi.destroySession();
      }
      if (portal === this.Portals.VENDOR) {
        VendorApi.destroySession();
      }
      VueCookies.remove(TOKEN_NAME);
    }
    router.push({
      name: 'login'
    });
  },

  dpkBasicConfig() {
    return {
      button: true,
      iconClass: 'fa fa-calendar',
      format: 'MM/dd/yyyy'
    };
  },

  numberFormat(value, style = 'currency', currency = 'USD') {
    value = value * 1;
    if (typeof value !== 'number') {
      return value;
    }
    const formatter = new Intl.NumberFormat(navigator.language, {style: style, currency: currency});
    return formatter.format(value);
  },

  Payments: (() => {
    let that = {};
    that.listYears = function() {
      return _.range(Moment().year(), Moment().add(15, 'years').year());
    };

    that.expMonths = (() => {
      return _.range(1, 13).map(month => month < 10 ? "0" + month : "" + month);
    })();

    that.moneyParameters = (() => {
      return {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        precision: 2,
        masked: false
      };
    })();

    return that;
  })()
};
